import { Base } from "../../../base/components/base"
import { Div } from "../../../base/components/native/div"
import { Img } from "../../../base/components/native/img"
import { Span } from "../../../base/components/native/span"
import { IMAGES } from "../../../configs/images"

export const HomeTitle = () => {
    const base = Base()

    const img = Img(IMAGES.ICONS.LOGO_DARK, { width: 171 })
    const desc = Span('( 1.1.0 )')
    desc.cssClass({ position: 'relative', top: '-3px', left: '10px', opacity: '0.4' })
    base.append(img, desc)

    base.cssClass({
        marginTop: '22px'
    })

    return base
}